import { createEffect, createEvent, createStore } from 'effector';
import { CITY_HEADER_KEY, DEFAULT_CITY_SLUG } from '../constants/global';
import Cookies from 'js-cookie';

export const setCity = createEvent<string>();
export const $city = createStore<string | null>(null).on(setCity, (_, city) => city);

export const initCity = createEffect(() => {
  const cookieCity = Cookies.get(CITY_HEADER_KEY);
  if (cookieCity) {
    return cookieCity;
  }
  Cookies.set(CITY_HEADER_KEY, DEFAULT_CITY_SLUG, { expires: 365 });
  return DEFAULT_CITY_SLUG;
});

$city.on(initCity.doneData, (_, city) => city);